export type BrowserMeasurements = {
    browserWidth: number;
    browserHeight: number;
    screenWidth: number;
    screenHeight: number;
    screenPixelRatio: number;
};

export const browserMeasurements = (window: Window): BrowserMeasurements => {
    if (typeof window === 'undefined') {
        return null;
    }

    return {
        browserWidth: window.innerWidth,
        browserHeight: window.innerHeight,
        screenWidth: window.screen.availWidth,
        screenHeight: window.screen.availHeight,
        screenPixelRatio: window.devicePixelRatio,
    };
};
